// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"style_dropdownMenu__QrRTx","item":"style_item__Nc0J6"};